export default __webpack_public_path__ + "static/media/Stanislao Nievo.bf60d531.jpg";